import { useMutation } from 'react-query';
import { survey } from '@services/Survey/Survey';
import { AxiosError } from 'axios';
import { ISurveyRequest } from '@interfaces/Survey.interface';

export function useSubmitSurveyForm() {
  return useMutation<string, AxiosError, ISurveyRequest>(async (ISurveyRequest) => {
    const { data: authData } = await survey.getAccessToken();
    const { data } = await survey.submitSurveyForm(
      ISurveyRequest.requestId,
      ISurveyRequest.requestData,
      authData.access_token,
      ISurveyRequest.recaptchaToken
    );
    return data;
  });
}
